import React, { Suspense } from "react";

import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import EditSubPackage from "../pages/subPackages/EditSubPackage";

const Dashboard = React.lazy(() => import("../pages//dashboard/Dashboard"));
const Login = React.lazy(() => import("../pages//login/Login"));

const PackagesList = React.lazy(() => import("../pages/packages/PackagesList"));

const SubPackagesList = React.lazy(() =>
  import("../pages/subPackages/SubPackagesList")
);
const SubPackage = React.lazy(() => import("../pages/subPackages/SubPackage"));
const AddSubPackage = React.lazy(() =>
  import("../pages/subPackages/AddSubPackage")
);

const TestimonialsList = React.lazy(() =>
  import("../pages/testimonials/Testimonials")
);

const ActivitiesList = React.lazy(() =>
  import("../pages/activities/Activities")
);

const TopAttractionsList = React.lazy(() =>
  import("../pages/topAttractions/TopAttractions")
);

const HotelsList = React.lazy(() => import("../pages/hotels/Hotels"));

const BookingsList = React.lazy(() => import("../pages/bookings/Bookings"));

const FAQList = React.lazy(() => import("../pages/faq/FaqList"));

const GalleryList = React.lazy(() => import("../pages/gallery/Gallery"));

const BlogsList = React.lazy(() => import("../pages/blogs/Blogs"));

const OffersList = React.lazy(() => import("../pages/offers/Offers"));
const TaxisList = React.lazy(() => import("../pages/taxis/Taxis"));
const TaxiBookingsList = React.lazy(() => import("../pages/taxiBookings/TaxiBookings"));

const Settings = React.lazy(() => import("../pages/settings/Settings"));

const AppRoutes = () => {
  const { isAuthenticated } = useSelector((state) => state.login);

  const protectedRoutes = [
    {
      path: "/",
      component: <Dashboard />,
    },
    {
      path: "/packages",
      component: <PackagesList />,
    },
    {
      path: "/sub-packages",
      component: <SubPackagesList />,
    },
    {
      path: "/sub-packages/add",
      component: <AddSubPackage />,
    },
    {
      path: "/sub-packages/view",
      component: <SubPackage />,
    },
    {
      path: "/sub-packages/edit",
      component: <EditSubPackage />,
    },
    {
      path: "/testimonials",
      component: <TestimonialsList />,
    },
    {
      path: "/activities",
      component: <ActivitiesList />,
    },
    {
      path: "/top-attractions",
      component: <TopAttractionsList />,
    },
    {
      path: "/hotels",
      component: <HotelsList />,
    },
    {
      path: "/bookings",
      component: <BookingsList />,
    },
    {
      path: "/faqs",
      component: <FAQList />,
    },
    {
      path: "/settings",
      component: <Settings />,
    },
    {
      path: "/gallery",
      component: <GalleryList />,
    },
    {
      path: "/blogs",
      component: <BlogsList />,
    },
    {
      path: "/offers",
      component: <OffersList />,
    },
    {
      path: "/taxis",
      component: <TaxisList />,
    },
    {
      path: "/taxi-bookings",
      component: <TaxiBookingsList />,
    },
  ];

  return (
    <Suspense fallback={<div>loading...</div>}>
      <Routes>
        {isAuthenticated ? (
          protectedRoutes?.map((route, index) => (
            <Route path={route.path} element={route.component} key={index} />
          ))
        ) : (
          <Route path="*" element={<Login />} />
        )}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
